<template>
  <div>
    <editor id="mobileTinymce" ref="tinymceEditor" v-model="value" :init="init"></editor>
  </div>
</template>

<script lang="ts">
import { Prop } from "vue-property-decorator";

import tinymce from "tinymce";

import "tinymce/themes/silver/theme.min.js";
import "tinymce/icons/default/icons";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/media";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/preview";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/hr";
import "tinymce/plugins/paste";
import "tinymce/plugins/indent2em";
import "tinymce/plugins/importword";
import "tinymce/plugins/layout";

import { Options, Vue } from "vue-class-component";

import Editor from "@tinymce/tinymce-vue";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { AppConfig } from "@/script/core/base/AppConfig";

@Options({
  name: "TinymceEditor",
  components: { Editor },
})
export default class extends Vue {
  @Prop({ default: "" }) content!: string;

  private value = "";

  // 富文本框init配置
  private get init() {
    return {
      selector: "#mobileTinymce",
      language_url: "/tinymce/langs/zh_CN.js",
      language: "zh_CN",
      skin_url: "/tinymce/skins/ui/oxide",
      height: 600,
      branding: false,
      plugins:
        "layout indent2em link lists image code table wordcount  media table fullscreen preview pagebreak insertdatetime hr paste", // 插件
      toolbar:
        "layout indent2em image bold italic underline alignleft aligncenter alignright alignjustify | forecolor backcolor | fontselect | fontsizeselect | formatselect |  bullist numlist | outdent indent blockquote | removeformat| undo redo | link unlink media insertdatetime table  hr pagebreak | fullscreen preview | strikethrough", // 工具条
      font_formats: "微软雅黑=Microsoft Yahei; 宋体=SimSun;", // 字体
      fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px 64px 72px", // 文字大小
      paste_data_images: true,
      codesample_languages: [
        { text: "HTML/XML", value: "markup" },
        { text: "JavaScript", value: "javascript" },
        { text: "CSS", value: "css" },
        { text: "Java", value: "java" },
        { text: "C++", value: "cpp" },
      ],
      content_style: "",
      // 图片上传回调
      images_upload_handler: (blobInfo: any, success: any) => {
        const file = blobInfo.blob();
        this.uploadFile(file, (url: any) => {
          success(url);
        });
      },
      layout_options: {
        style: {},
        filterTags: [], // 忽略
        clearStyle: [], // 清除
        tagsStyle: {
          table: {
            width: "100%",
          },
          img: {
            width: "100%",
            height: "auto",
          },
          p: {
            "word-break": "break-all",
          },
        },
      },
    };
  }

  mounted() {
    tinymce.init({});
    this.value = this.content;
  }

  setContent(str: any) {
    this.value = str;
  }

  getContent() {
    return this.value;
  }

  uploadFile(file: any, callback: any) {
    const service = new ContentService();
    const path = "mobile/cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", file, file.name);
    service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        callback(uploadUrl);
      },
      (error: Error) => {
        console.error(error);
      }
    );
  }
}
</script>

<style lang="scss" scoped></style>
